module.exports = __webpack_public_path__ + "static/sport/left.552e00b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/september10/left.gif
// module id = v/Te
// module chunks = 0